import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Koristimo kolačiće',
    description:
      'Koristimo kolačiće i slične tehnologije za funkcionisanje ovog iskustva. Neophodni kolačići su uvek aktivni.',
    allow_label: 'Prihvati sve kolačiće',
    reject_label: 'Samo neophodni',
    settings_label: 'Podešavanja kolačića',
    policy_link_label: 'Politika privatnosti i kolačića',
    categories_label: 'Kategorije',
    always_on_label: 'Uvek aktivno',
    required_label: 'Obavezno',
    save_preferences_label: 'Sačuvaj podešavanja',
    close_label: 'Zatvori',
    allow_all_optional_categories_label: 'Dozvoli sve opcione kategorije',
    save_error: 'Nismo uspeli da sačuvamo vaš izbor privatnosti. Pokušajte ponovo.'
  },
  categories: {
    strictly_necessary: {
      name: 'Neophodni',
      purpose: 'Neophodni su za funkcionisanje ovog iskustva i ne mogu se isključiti.'
    },
    analytics: {
      name: 'Analitika',
      purpose: 'Mere kako posetioci koriste ovo iskustvo kako bi se poboljšale performanse.'
    },
    marketing: { name: 'Marketing', purpose: 'Podržavaju oglašavanje i marketing koje je izabrao organizator.' }
  }
};

export default locale;
